import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../lib/smooth";

const LINKS = [
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Shop", href: "#shop" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "Pricing", href: "#pricing" },
    { label: "Contact", href: "#contact" },
];

export const Header = ({ onBook }) => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (href) => {
        setOpen(false);
        scrollToId(href);
    };

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 backdrop-blur-xl bg-[#081226]/80 border-b ${scrolled ? "border-white/10" : "border-white/5"}`}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
                <button
                    data-testid="header-logo"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="flex items-center group"
                >
                    <span className="flex items-center gap-2.5">
                        <img src="/assets/logo_mark.png" alt="Ink of Destiny" className="h-10 w-auto group-hover:drop-shadow-[0_0_12px_rgba(201,169,98,0.5)] transition-all" />
                        <span className="font-display italic text-lg text-[#F0EBE0]">Ink of <span className="text-[#C9A962]">Destiny</span></span>
                    </span>
                </button>

                <nav className="hidden lg:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <button
                            key={l.href}
                            data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            onClick={() => go(l.href)}
                            className="text-xs uppercase tracking-[0.2em] text-[#A19D94] hover:text-[#C9A962] transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="header-book-btn"
                        onClick={onBook}
                        className="ml-2 px-6 py-2.5 rounded-full bg-[#C9A962] text-[#081226] text-xs font-semibold uppercase tracking-[0.15em] hover:bg-[#dcc083] hover:shadow-[0_0_25px_rgba(201,169,98,0.4)] transition-all"
                    >
                        Book Consultation
                    </button>
                </nav>

                <button
                    data-testid="mobile-menu-toggle"
                    className="lg:hidden text-[#F0EBE0]"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {open && (
                <div data-testid="mobile-menu" className="lg:hidden border-t border-white/5 bg-[#081226]/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
                    {LINKS.map((l) => (
                        <button
                            key={l.href}
                            data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            onClick={() => go(l.href)}
                            className="text-left text-sm uppercase tracking-[0.2em] text-[#A19D94] hover:text-[#C9A962] transition-colors"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        data-testid="mobile-book-btn"
                        onClick={() => { setOpen(false); onBook(); }}
                        className="mt-2 px-6 py-3 rounded-full bg-[#C9A962] text-[#081226] text-xs font-semibold uppercase tracking-[0.15em]"
                    >
                        Book Consultation
                    </button>
                </div>
            )}
        </header>
    );
};
